import { MASTER_POLICY_DATA } from "../_mock/mock";

const STORAGE_KEY = "hmis-policy-master-records-v1";

/** Fired on `window` after policies are written so list pages can refresh. */
export const POLICY_MASTER_UPDATED = "hmis-policy-master-updated";

function readList() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null || raw === undefined) return undefined;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
}

function writeList(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

function notify() {
  window.dispatchEvent(new CustomEvent(POLICY_MASTER_UPDATED));
}

/**
 * Returns persisted policy rows. First time (no storage key), seeds a copy of mock data.
 */
export function getPolicyRecords() {
  const existing = readList();
  if (existing === undefined) {
    const seeded = JSON.parse(JSON.stringify(MASTER_POLICY_DATA || []));
    writeList(seeded);
    return seeded;
  }
  return existing;
}

/**
 * Insert or update a policy by `id` / `_id`, then persist and notify listeners.
 */
export function upsertPolicy(record) {
  let list = readList();
  if (list === undefined) {
    list = JSON.parse(JSON.stringify(MASTER_POLICY_DATA || []));
  } else {
    list = list.slice();
  }

  const id = record.id ?? record._id;
  const idx = list.findIndex((r) => (r.id ?? r._id) === id);

  if (idx >= 0) {
    list[idx] = { ...list[idx], ...record, id: list[idx].id ?? list[idx]._id ?? id };
  } else {
    const newId = id != null ? id : Date.now();
    list.push({ ...record, id: newId });
  }

  writeList(list);
  notify();
}
